import { z } from 'zod';
import { ID } from '../../utils/codecUtils';

export const deleteEndpoint = (savedViewId: ID) => {
  return {
    endpoint: `/saved_views/${savedViewId}`,
    method: 'DELETE',
    responseSchema: z.unknown(),
  } as const;
};
